/**
 * PDP shade grid — SKU order (#1 first), click to open that shade.
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function shadeNum(el) {
    var n = parseInt(el.getAttribute('data-shade-num'), 10);
    if (!isNaN(n) && n > 0) return n;
    var sku = el.getAttribute('data-shade-sku') || '';
    var m = sku.match(/(\d+)\s*$/);
    return m ? parseInt(m[1], 10) : 999;
  }

  function sortList(list) {
    var items = Array.prototype.slice.call(list.querySelectorAll('.viimpii-pdp-available-shades__item'));
    if (items.length < 2) return;
    items.sort(function (a, b) {
      return shadeNum(a) - shadeNum(b);
    });
    items.forEach(function (el) {
      list.appendChild(el);
    });
  }

  function enhance(root) {
    if (!root || root.dataset.scrollReady === '1') return;

    var trapped = root.closest('.quantity-selector-wrapper, .quantity-selector');
    if (trapped) {
      var buyButtons = document.querySelector('.product-details .buy-buttons-block');
      var qtyWrap = document.querySelector('.product-details .quantity-selector-wrapper');
      if (buyButtons) {
        buyButtons.insertAdjacentElement('beforebegin', root);
      } else if (qtyWrap && qtyWrap !== root) {
        qtyWrap.insertAdjacentElement('beforebegin', root);
      }
    }

    var list = root.querySelector('.viimpii-pdp-available-shades__list');
    if (!list) return;

    root.dataset.scrollReady = '1';

    root.querySelectorAll('.viimpii-pdp-available-shades__nav').forEach(function (btn) {
      btn.remove();
    });

    sortList(list);
    list.setAttribute('dir', 'ltr');

    list.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a.viimpii-pdp-available-shades__item');
      if (!link) return;

      if (link.classList.contains('is-current')) {
        e.preventDefault();
        return;
      }

      var href = link.getAttribute('href') || link.getAttribute('data-shade-url');
      if (!href || href === '#' || href === '') return;

      e.preventDefault();
      window.location.href = href;
    });
  }

  function scan() {
    document.querySelectorAll('.product-details .viimpii-pdp-available-shades').forEach(enhance);
  }

  ready(function () {
    scan();
    setTimeout(scan, 50);
    setTimeout(scan, 250);
    setTimeout(scan, 800);
    document.addEventListener('viimpii:shades-ready', scan);
    var obs = new MutationObserver(scan);
    obs.observe(document.body, { childList: true, subtree: true });
  });
})();
